export const noNavigateNotifications: Record<string, string[]> = {
  job: ['unassigned']
}
